import {Injectable, inject} from '@angular/core';
import {LocalStorageService} from "./local-storage.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private localStorageService: LocalStorageService = inject(LocalStorageService);

  public editing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private deviceID: string | null = null;
  private tabId: string = this.generateTabId();

  public constructor() {
    this.setDeviceID(this.getStoredDeviceID());
  }

  public getTabId(): string {
    return this.tabId;
  }

  public setDeviceID(deviceID: string | null): void {
    this.deviceID = deviceID;
  }

  public getDeviceID(): string | null {
    return this.deviceID;
  }

  public getStoredDeviceID(): string | null {
    if (this.localStorageService.getLocalStorage('deviceID')) {
      return this.localStorageService.getLocalStorage('deviceID');
    }

    const deviceID = Math.random().toString(36).slice(2);
    this.localStorageService.setLocalStorage('deviceID', deviceID);
    return deviceID;
  }

  public setEditing(editing: boolean): void {
    this.editing.next(editing);
  }

  public getEditing(): boolean {
    return this.editing.value;
  }

  private generateTabId(): string {
    const webCrypto = globalThis.crypto;

    if (webCrypto?.randomUUID) {
      return webCrypto.randomUUID();
    }

    if (webCrypto?.getRandomValues) {
      const bytes = new Uint8Array(16);
      webCrypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;

      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}
